import React from 'react';
import { Route, Routes } from 'react-router-dom';

import { ForecastingRoutes } from '@futrli/predict-next/forecasting/dashboard/routes';
import { ForecastingTabId } from '@futrli/predict-next/forecasting/dashboard/containers/forecasting-dashboard-container-new';
import { ROUTES } from '@futrli/shared-services';

import { ForecastContainerFR } from '../detail/containers/forecast-container-fr';
import { ForecastContainerUK } from '../detail/containers/forecast-container-uk';
import { SidePanelContextProvider } from '../detail/containers/side-panel';
import { usePredictManagementContext } from '../../predict-management/context/predict-management-context';

export const ForecastingContainer = () => {
  const { financialConfig } = usePredictManagementContext();

  return (
    <SidePanelContextProvider>
      <Routes>
        <Route index element={<ForecastingRoutes />} />
        <Route path={`${ForecastingTabId.FORECASTS_LIST}/*`} element={<ForecastingRoutes />} />
        <Route path={`${ForecastingTabId.PERFORMANCE_COMPARISON}/*`} element={<ForecastingRoutes />} />

        <Route
          path={`${ROUTES.FORECAST_BY_ID}/*`}
          element={
            <>
              {financialConfig?.accounting_rules === 'french' && <ForecastContainerFR />}
              {financialConfig?.accounting_rules === 'default' && <ForecastContainerUK />}
            </>
          }
        />
      </Routes>
    </SidePanelContextProvider>
  );
};
